import type { MotionProps, Variants } from "motion/react";
import type { TargetPlacement } from "./TargetPositioner";

export const positionerVariants = (
  offSet: number = 12,
  duration: number = 0.2,
): Record<TargetPlacement, Variants> => ({
  top: {
    initial: { opacity: 0, y: -offSet, transition: { duration } },
    animate: { opacity: 1, y: 0, transition: { duration } },
    exit: { opacity: 0, y: -offSet, transition: { duration } },
  },
  bottom: {
    initial: { opacity: 0, y: offSet, transition: { duration } },
    animate: { opacity: 1, y: 0, transition: { duration } },
    exit: { opacity: 0, y: offSet, transition: { duration } },
  },
  left: {
    initial: { opacity: 0, x: -offSet, transition: { duration } },
    animate: { opacity: 1, x: 0, transition: { duration } },
    exit: { opacity: 0, x: -offSet, transition: { duration } },
  },
  leftTop: {
    initial: { opacity: 0, x: -offSet, transition: { duration } },
    animate: { opacity: 1, x: 0, transition: { duration } },
    exit: { opacity: 0, x: -offSet, transition: { duration } },
  },
  right: {
    initial: { opacity: 0, x: offSet, transition: { duration } },
    animate: { opacity: 1, x: 0, transition: { duration } },
    exit: { opacity: 0, x: offSet, transition: { duration } },
  },
  rightTop: {
    initial: { opacity: 0, x: offSet, transition: { duration } },
    animate: { opacity: 1, x: 0, transition: { duration } },
    exit: { opacity: 0, x: offSet, transition: { duration } },
  },
  topLeft: {
    initial: { opacity: 0, y: -offSet, transition: { duration } },
    animate: { opacity: 1, y: 0, transition: { duration } },
    exit: { opacity: 0, y: -offSet, transition: { duration } },
  },
  topRight: {
    initial: { opacity: 0, y: -offSet, transition: { duration } },
    animate: { opacity: 1, y: 0, transition: { duration } },
    exit: { opacity: 0, y: -offSet, transition: { duration } },
  },
  bottomLeft: {
    initial: { opacity: 0, y: offSet, transition: { duration } },
    animate: { opacity: 1, y: 0, transition: { duration } },
    exit: { opacity: 0, y: offSet, transition: { duration } },
  },
  bottomRight: {
    initial: { opacity: 0, y: offSet, transition: { duration } },
    animate: { opacity: 1, y: 0, transition: { duration } },
    exit: { opacity: 0, y: offSet, transition: { duration } },
  },
  center: {
    initial: { opacity: 0, transition: { duration } },
    animate: { opacity: 1, transition: { duration } },
    exit: { opacity: 0, transition: { duration } },
  },
});

export const positionerTransition: MotionProps["transition"] = {
  duration: 0.2,
  ease: "easeOut" as const,
};
